var map = {
	"./404.svg": "a14a",
	"./account.svg": "ef22",
	"./acount.svg": "fe88",
	"./advertise.svg": "cb0d",
	"./base.svg": "3f0e",
	"./baseModule.svg": "6a97",
	"./bug.svg": "1779",
	"./chart.svg": "c829",
	"./clipboard.svg": "bc35",
	"./component.svg": "56d6",
	"./dashboard.svg": "f782",
	"./day.svg": "b4d0",
	"./device.svg": "2c87",
	"./devices.svg": "1a96",
	"./devicesNum.svg": "74b7",
	"./documentation.svg": "90fb",
	"./drag.svg": "9bbf",
	"./edit.svg": "aa46",
	"./email.svg": "cbb7",
	"./example.svg": "30c3",
	"./excel.svg": "6599",
	"./eye.svg": "4df5",
	"./field.svg": "d957",
	"./finace.svg": "24a7",
	"./form.svg": "eb1b",
	"./guide 2.svg": "2027",
	"./guide.svg": "6683",
	"./home.svg": "6bbe",
	"./icon.svg": "9d91",
	"./international.svg": "17df",
	"./language.svg": "2580",
	"./link.svg": "18f0",
	"./list.svg": "3289",
	"./lock.svg": "ab00",
	"./message.svg": "47ff",
	"./money.svg": "3046",
	"./month.svg": "a3c6",
	"./nested.svg": "dcf8",
	"./order.svg": "11ff",
	"./password.svg": "2a3d",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./place.svg": "3476",
	"./qq.svg": "1430",
	"./shopping.svg": "12a5",
	"./size.svg": "8644",
	"./star.svg": "708a",
	"./tab.svg": "8fb7",
	"./table.svg": "47f1",
	"./template.svg": "dcbb",
	"./theme.svg": "e534",
	"./tree.svg": "93cd",
	"./user.svg": "b3b5",
	"./userManage.svg": "c1bc",
	"./wechat.svg": "80da",
	"./week.svg": "42f7",
	"./year.svg": "5bf5",
	"./zip.svg": "8aa6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";